'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import type { ReactNode } from 'react'

import { AppUiVisual } from '../app-ui-visual'
import { client, HAS_ROOM, MONTH_DEADLINE_DAY, teamMember, UNSTARTED_VAT } from '../demo-data'
import { useVisualCopy } from '../visual-copy'
import { AppHeader, AppScreen } from './app-screen'

/** Sparkle glyph in a 24px accent-soft rounded square (matches the AI-chat header elsewhere). */
function SparkleIcon() {
  return (
    <span
      className="flex size-[24px] shrink-0 items-center justify-center rounded-[7px]"
      style={{ background: 'var(--au-accent-soft)' }}
    >
      <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden>
        <path
          d="M8 1L9.4 6.6L15 8L9.4 9.4L8 15L6.6 9.4L1 8L6.6 6.6L8 1Z"
          stroke="var(--au-accent)"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

/** Bold entity name inside an answer bubble (client or colleague), in the main text color. */
function Name({ children }: { children: ReactNode }) {
  return (
    <b className="font-semibold" style={{ color: 'var(--au-text)' }}>
      {children}
    </b>
  )
}

function QuestionBubble({ children }: { children: ReactNode }) {
  return (
    <div className="flex justify-end">
      <div
        className="max-w-[88%] px-2.5 py-1.5 text-[11.5px] leading-snug font-medium text-white"
        style={{ background: 'var(--au-accent)', borderRadius: '13px 13px 4px 13px' }}
      >
        {children}
      </div>
    </div>
  )
}

function AnswerBubble({ children }: { children: ReactNode }) {
  return (
    <div className="flex justify-start">
      <div
        className="max-w-[92%] px-2.5 py-1.5 text-[11.5px] leading-snug"
        style={{ background: 'var(--au-field)', color: 'var(--au-text2)', borderRadius: '13px 13px 13px 4px' }}
      >
        {children}
      </div>
    </div>
  )
}

/**
 * Planning-page AI strip — a fixed, module-specific chat (Offsoo-assistent via MCP) with the
 * planning conversation from `Planning.dc.html`: two exchanges about which VAT returns haven't
 * started and who still has capacity this week. Unlike the homepage `AiChatVisual` (a looping
 * single-exchange animation) this is the design's static full conversation; `AppUiVisual` still
 * fades it in on scroll.
 */
export function PlanningAiChatVisual({ className }: { className?: string }) {
  const { t, fmt } = useVisualCopy()
  return (
    <AppUiVisual label="Vraag het aan de planning via een AI-assistent" className={className}>
      <AppScreen>
        <div className="flex h-full flex-col">
          <AppHeader
            leading={<SparkleIcon />}
            title="Offsoo-assistent"
            right={
              <span
                className="rounded-[5px] px-1.5 py-0.5 text-[9px] font-bold whitespace-nowrap"
                style={{ background: 'var(--au-accent-soft)', color: 'var(--au-accent)' }}
              >
                MCP
              </span>
            }
          />

          <div className="flex flex-1 flex-col justify-center gap-2 px-4 py-3.5">
            <QuestionBubble>{t.chat.planning.question}</QuestionBubble>
            <AnswerBubble>
              {UNSTARTED_VAT.length} {t.word.clientsLower}:{' '}
              {UNSTARTED_VAT.map((nr, index) => (
                <span key={nr}>
                  {index > 0 && (index === UNSTARTED_VAT.length - 1 ? t.chat.and : t.chat.comma)}
                  <Name>{client(nr).short}</Name>
                </span>
              ))}{' '}
              — {UNSTARTED_VAT.length === 3 ? t.chat.planning.allThreeWithDeadline : t.chat.planning.allWithDeadline}{' '}
              {fmt.dayMonth(MONTH_DEADLINE_DAY)}.
            </AnswerBubble>
            <QuestionBubble>{t.chat.planning.followUp}</QuestionBubble>
            <AnswerBubble>
              {HAS_ROOM.slice(0, 2).map((row, index) => (
                <span key={row.member}>
                  {index > 0 && t.chat.and}
                  <Name>{teamMember(row.member).firstName}</Name> {t.chat.planning.isAt} {row.pct}%
                </span>
              ))}{' '}
              {t.chat.planning.enoughRoom}
            </AnswerBubble>
          </div>
        </div>
      </AppScreen>
    </AppUiVisual>
  )
}
